/* eslint-disable import/prefer-default-export */
export const SET_TOKEN = "set-token"
